<div class="box-management">
  <div class="col-12">
    <div class="title-box" style="color: #2c657f;">
      <i class="app-icon-tag" style="margin-right: 8px;"></i>
      SUAS OFERTAS
    </div>
    <div class="bid-event">
      <ul>
        <li *ngFor="let alternativeBid of alternativeBinds">
          <span class="label">
            {{alternativeBid.createdAt | amTimeAgo}}
          </span>
          <div class="value">
            <div><span class="currency-symbol">R$</span> {{alternativeBid.value | number}}</div>
          </div>
          <span class="label"
            [ngClass]="{'label-reject': alternativeBid.status === 'REJECTED', 'label-accept': alternativeBid.status === 'ACCEPTED'}">
            {{ getLabel(alternativeBid) }}
            <ng-container *ngIf="alternativeBid.statusChangedAt">
              {{alternativeBid.statusChangedAt | amTimeAgo}}
            </ng-container>
          </span>
        </li>
      </ul>
    </div>
  </div>
</div>